/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {
  UPDATE_CLAUSES_PER_PAGE(state, value) {
    state.clausesPerPage = value;
  },

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
// ""

  SET_DEV_MODE(state) {
    state.isDev = true
  },

  INC_FILE_ORDER(state) {
    state.file_order++;
  },

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },

  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val
  },
  UPDATE_THEME(state, val) {
    state.theme = val
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val
  },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  UPDATE_USER_TOKEN(state, payload) {
    state.token = payload;

  },
  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, payload) {
    state.userInfo = payload;
  },

  SET_BANKS(state, payload) {
    state.banks = payload;
  },
  ADD_BANK(state, payload) {
    state.banks.push(payload)
  },
  REMOVE_BANK(state, payload) {
    const index = state.banks.findIndex(bank => bank.name === payload.name);
    state.banks.splice(index, 1);
  },
  SET_CLAUSES(state, payload) {
    state.clauses = payload
  },
  ADD_CLAUSE(state, payload) {
    state.clauses.push(payload)
  },
  REMOVE_CLAUSE(state, payload) {
    const index = state.clauses.findIndex(clause => clause.id === payload);
    state.clauses.splice(index, 1);
  },
  DEPRECIATE_CLAUSE(state, payload) {
    const index = state.clauses.findIndex(clause => clause.id === payload.id);
    state.clauses.splice(index, 1, { ...state.clauses[index], archived: true, next: payload.next });
  },
  SET_TRUNCATE(state, payload) {
    state.truncate = payload;
  },
  SET_ID(state, payload) {
    state.id = payload;
  },
  RENAME_BANK(state, payload) {
    const index = state.banks.findIndex(bank => bank.name === payload.old);
    state.banks.splice(index, 1, {...state.banks[index], name: payload.new});
  }
}

export default mutations

